import { Stack, useTheme } from '@mui/material'
import React from 'react'
import { HiArrowsUpDown, HiArrowPathRoundedSquare } from 'react-icons/hi2'
import { IoIosSend } from 'react-icons/io'
import { TbCurrencyDollar } from 'react-icons/tb'
import { FiPlus } from 'react-icons/fi'
import { ROUTES } from '@utils/routes'
import { ActionButton, IActionButtonProps } from './ActionButton'
import { useDevMode } from '@plug-core/state'
import useWallet from '@plug-core/hooks/useWallet'
import { openOnramper } from '@utils/onramper'

export const ActionButtons = () => {
  const {
    palette: {
      rainbow: { red, blue, green, yellow, purple },
    },
  } = useTheme()

  const { devEnabled } = useDevMode()
  const { wallet } = useWallet()

  const actions: IActionButtonProps[] = [
    {
      color: red,
      icon: FiPlus,
      label: 'Receive',
      route: ROUTES.ADDRESSES,
    },
    {
      color: blue,
      icon: IoIosSend,
      label: 'Send',
      route: ROUTES.SEND,
    },
  ]

  const mainnetActions: IActionButtonProps[] = [
    {
      color: green,
      icon: HiArrowsUpDown,
      label: 'Swap',
      route: ROUTES.SWAP,
    },
    {
      color: yellow,
      icon: HiArrowPathRoundedSquare,
      label: 'Convert',
      route: ROUTES.CONVERT,
    },
  ]

  const buyButton = {
    color: purple,
    icon: TbCurrencyDollar,
    label: 'Buy',
    onClick: () => openOnramper(wallet),
  }

  return (
    <Stack
      direction="row"
      borderRadius={2}
      bgcolor="background.paper"
      paddingY={1}
      paddingX={0.25}
      marginX="auto"
      mb={0.5}
      width="calc(100% - 24px - 4px)"
      justifyContent="space-evenly"
    >
      {(devEnabled ? actions : [...actions, ...mainnetActions, buyButton]).map((action, index) => (
        <ActionButton key={index} {...action} />
      ))}
    </Stack>
  )
}
